import { datadogRum } from '@datadog/browser-rum';

const reportDatadogAction = (
  startTime: number,
  endpoint: string,
  response: Response,
) => {
  const duration = performance.now() - startTime;

  datadogRum.addAction(endpoint, {
    method: 'GET',
    duration_ms: duration,
    status_text: response.statusText,
  });
};

const reportDatadog = async (
  startTime: number,
  endpoint: string,
  errorObject: Error,
) => {
  const duration = performance.now() - startTime;

  datadogRum.addError(errorObject, {
    endpoint: endpoint,
    method: 'GET',
    duration_ms: duration,
  });
};

export { reportDatadogAction, reportDatadog };
